export default __webpack_public_path__ + "static/media/UserImagePlaceholder.7730cf3c.png";